(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-info"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const swiper = new Swiper('.footer-info-slider', {
      cssMode: true,
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints:{
        750: {
          slidesPerView: 2,
        },
        910: {
          slidesPerView: 3
        },
        1200: {
          slidesPerView: 4
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon_text_section"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if (window.matchMedia("(max-width: 768px)").matches) { // Only run on mobile
      if (document.querySelector('.icon-text-section.snap')) {
        let scrollContainer = document.querySelector('.icon-text-section.snap .icon-text-section__blocks');
        setInterval(() => {
          let scrollAmount = scrollContainer.scrollLeft + scrollContainer.clientWidth + 50;  // 50 is the gap on the left 
          if (scrollAmount >= scrollContainer.scrollWidth) {
            scrollContainer.scrollTo({left: 0, behavior: 'smooth'});
          } else {
            scrollContainer.scrollBy({left: scrollContainer.clientWidth, behavior: 'smooth'});
          }
        }, 4000);
      }
    }
  });


  } catch(e) { console.error(e); }
})();
})();
